import React from "react";
import { Icon } from "@iconify/react";
export function AccountMenuItem({ icon, identifier, label, selected = false, onMenuItemClicked }) {
    return (React.createElement("button", { className: `flex gap-5 px-4 ${selected ? "font-semibold text-primary" : "text-dark-gray"}`, onClick: onMenuItemClicked(identifier) },
        React.createElement(Icon, { className: "text-2xl", icon: icon }),
        React.createElement("div", { className: "my-auto text-left" }, label)));
}
